import { IAgenciesPageProps } from 'client/common/pages/agencies';

import { IAppData } from 'client/common/types';

export function getAgenciesPageProps(data: IAppData): IAgenciesPageProps {
    return { ...data.agenciesPage, tld: data.tld, regions: data.regions };
}
